import { render } from "./TraiterDemandeInscription.vue?vue&type=template&id=3e8a254e&scoped=true&ts=true"
import script from "./TraiterDemandeInscription.vue?vue&type=script&lang=ts"
export * from "./TraiterDemandeInscription.vue?vue&type=script&lang=ts"

import "./TraiterDemandeInscription.vue?vue&type=style&index=0&id=3e8a254e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8a254e"]])

export default __exports__